import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Production-optimized render - no StrictMode double rendering
document.querySelectorAll("[data-prerender]").forEach((el) => el.remove());
createRoot(document.getElementById("root")!).render(<App />);